<template>
  <div>
    <c-loading-area v-if="showPaymentOptions" :loading="loading">
      <v-card-title>
        {{ $t('page.makePayment.paymentOptions.title') }}
      </v-card-title>
      <v-card-subtitle>
        {{ $t('page.makePayment.paymentOptions.subTitle') }}
      </v-card-subtitle>
      <v-card-text>
        <template v-if="hasPaymentOptions">
          <v-list class="pt-0" v-for="(item, i) in bean.paymentOptionResults" :key="item.paymentOptionID">
            <v-divider v-if="i !== 0"/>
            <action-list-item
              @click="save(item.paymentOptionID)"
              :title="item.paymentOptionName"
              :description="item.paymentOptionDescription">
              <template #subtext>
                <div class="mt-2">
                  <span class="font-weight-medium">
                    {{ $t('page.makePayment.paymentOptions.paymentAmount') }}
                  </span>
                  {{ item.wouldBeAmount | formatCurrency }}
                </div>
              </template>
            </action-list-item>
          </v-list>
        </template>
        <cutout-area v-else class="mt-6 mb-6">
          {{ $t('global.noneFound') }}
        </cutout-area>
      </v-card-text>
    </c-loading-area>
  </div>
</template>

<script>
import CutoutArea from '@components/support/CutoutArea';
import WorkflowStepMixin from '@/mixins/workflowStep';
import { useUserStore } from '@/stores/userStore';
import axios from 'axios';
import _ from 'lodash';

const userStore = useUserStore();

export default {
  components: { CutoutArea },
  mixins: [ WorkflowStepMixin ],
  data () {
    return {
      showPaymentOptions: true
    };
  },
  computed: {
    hasPaymentOptions () {
      return _.size(this.bean.paymentOptionResults) > 0;
    }
  },
  methods: {
    loadData () {
      let query = {
        caseInstanceUUID: this.bean.selections.caseInstanceUUID,
        casePartyUUID: this.bean.selections.casePartyUUID,
        localeCode: userStore.localeCode
      };

      return axios.get(this.$cove.getAPI({ name: 'api.party.paymentoptions', query }))
        .then((response) => {
          this.bean.paymentOptionResults = response.data.paymentOptionInstances;
        }).catch((error) => {
          this.showPaymentOptions = false;
          console.error(error);
        });
    },
    save (paymentOptionID) {
      let paymentOption = _.find(this.bean.paymentOptionResults, ['paymentOptionID', paymentOptionID]);
      this.bean.selections.paymentOptionID = paymentOption.paymentOptionID;
      this.bean.selections.amount = paymentOption.wouldBeAmount;
      this.$emit('save', this.bean);
    }
  }
};
</script>
